import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Cookies from "js-cookie";

const DEFAULT_CLIENT_ID = "SEU_CLIENT_ID_AQUI";

function GoogleLoginButton({ onLoginSuccess, clientId = DEFAULT_CLIENT_ID, buttonId = "google-login-button" }) {
  useEffect(() => {
    if (window.google && window.google.accounts && window.google.accounts.id) {
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: handleCredentialResponse,
      });

      const btnElement = document.getElementById(buttonId);
      if (btnElement) {
        window.google.accounts.id.renderButton(btnElement, {
          theme: "outline",
          size: "large",
        });
      }
    }
  }, [clientId, buttonId]);

  const handleCredentialResponse = (response) => {
    Cookies.set("google_token", response.credential, { expires: 1 });

    if (onLoginSuccess) {
      onLoginSuccess(response);
    }
  };

  return <div id={buttonId}></div>;
}

GoogleLoginButton.propTypes = {
  onLoginSuccess: PropTypes.func,
  clientId: PropTypes.string,
  buttonId: PropTypes.string,
};

export default GoogleLoginButton;



// WEBPACK FOOTER //
// ./src/design-system/atoms/GoogleLoginButton/GoogleLoginButton.jsx